<template>
  <v-card class="mb-6">
    <v-row dense>
      <v-col cols="4">
        <v-card-title>
          部位
        </v-card-title>
        <v-card-subtitle
          class="black--text pt-3"
          v-bind="diffAttributes(previousObject.name, item.name)">
          <edit-dialog
            v-model="item.name"
            :error-messages="error[`rooms.${roomIndex}.parts.${index}.name`]">
            <template #text>
              <span style="font-size: 1.5em">
                {{ item.name }}
              </span>
            </template>
          </edit-dialog>
          <div class="previous-value">
            {{ previousValue(previousObject.name, item.name) }}
          </div>
        </v-card-subtitle>
      </v-col>
      <v-col cols="2">
        <v-card-title>
          改修年
        </v-card-title>
        <v-card-subtitle
          class="black--text"
          v-bind="diffAttributes(previousObject.renovation_year, item.renovation_year)">
          <select-year
            v-model="item.renovation_year"
            :error-messages="error[`rooms.${roomIndex}.parts.${index}.renovation_year`]" />
          <div class="previous-value">
            {{ previousValue(previousObject.renovation_year, item.renovation_year) }}
          </div>
        </v-card-subtitle>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-card :elevation="0">
          <v-data-table
            hide-default-footer
            fixed-header
            :headers="headers"
            :items="item.surveys"
            :hide-default-header="item.surveys.length === 0"
            disable-sort
            no-data-text="書面調査情報が入力されていません +ボタンで追加してください。"
            dense>
            <template #item.written_material="props">
              <div
                v-bind="diffAttributes(
                  getPreviousSurvey(props.item, 'written_material'), props.item.written_material)">
                <edit-dialog v-model="props.item.written_material">
                  <v-text-field
                    v-model="props.item.written_material"
                    class="mt-5"
                    width="150px"
                    label="現地確認建材名・商品名"
                    counter
                    autofocus
                    outlined
                    dense />
                </edit-dialog>
                <div class="previous-value">
                  {{ previousValue(getPreviousSurvey(
                    props.item, 'written_material'), props.item.written_material) }}
                </div>
              </div>
            </template>
            <template #item.written_remarks="props">
              <div
                v-bind="diffAttributes(
                  getPreviousSurvey(props.item, 'written_remarks'),
                  props.item.written_remarks
                )">
                <v-combobox
                  v-model="props.item.written_remarks"
                  :items="remarkOptions"
                  style="min-width: 130px;"
                  hide-details
                  dense />
                <div class="previous-value">
                  {{ previousValue(getPreviousSurvey(
                    props.item, 'written_remarks'), props.item.written_remarks) }}
                </div>
              </div>
            </template>
            <template #item.has_drawings="props">
              <div
                v-bind="diffAttributes(
                  getPreviousSurvey(props.item, 'has_drawings'), props.item.has_drawings)">
                <select-dialog
                  v-model="props.item.has_drawings"
                  :select-items="drawings"
                  item-text="value"
                  item-value="id"
                  @change="onHasDrawingsChanged(props.item)" />
                <div class="previous-value">
                  {{ previousValue(
                    getPreviousSurvey(props.item, 'has_drawings'),
                    props.item.has_drawings,
                    drawings,
                  ) }}
                </div>
              </div>
            </template>
            <template #item.written_status_id="props">
              <div
                v-bind="diffAttributes(
                  getPreviousSurvey(props.item, 'written_status_id'),
                  props.item.written_status_id
                )">
                <select-dialog
                  v-model="props.item.written_status_id"
                  :select-items="statuses"
                  item-text="value"
                  item-value="id" />
                <div class="previous-value">
                  {{ previousValue(getPreviousSurvey(
                    props.item, 'written_status_id'), props.item.written_status_id, statuses) }}
                </div>
              </div>
            </template>
            <template #item.written_reason_id="props">
              <div
                v-bind="diffAttributes(
                  getPreviousSurvey(props.item, 'written_reason_id'),
                  props.item.written_reason_id
                )">
                <select-dialog
                  v-model="props.item.written_reason_id"
                  :select-items="reasons"
                  item-text="value"
                  item-value="id" />
                <div class="previous-value">
                  {{ previousValue(getPreviousSurvey(
                    props.item, 'written_reason_id'), props.item.written_reason_id, reasons) }}
                </div>
              </div>
            </template>
            <template #item.analysis_scheduled="props">
              <div
                v-bind="diffAttributes(
                  getPreviousSurvey(props.item, 'analysis_scheduled'),
                  props.item.analysis_scheduled
                )">
                <v-combobox
                  v-model="props.item.analysis_scheduled"
                  :items="scheduledItems"
                  style="min-width: 130px;"
                  hide-details
                  dense />
                <div class="previous-value">
                  {{ previousValue(
                    getPreviousSurvey(props.item, 'analysis_scheduled'),
                    props.item.analysis_scheduled,
                    scheduledItems,
                  ) }}
                </div>
              </div>
            </template>
            <template #item.delete="props">
              <v-btn
                v-if="!readonly"
                class="delete-part"
                fab
                dark
                small
                color="red"
                @click="onDeletionButtonClicked(props.item)">
                <v-icon dark>mdi-minus</v-icon>
              </v-btn>
            </template>
            <template
              v-if="!readonly"
              #body.append>
              <tr>
                <td
                  colspan="10"
                  class="text-center">
                  <v-btn
                    class="add-part"
                    fab
                    dark
                    small
                    color="primary"
                    @click="onAddRowButtonClicked">
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import EditDialog from '../EditDialog'
import SelectDialog from '../SelectDialog'
import SelectYear from '../SelectYear'
import PreviousDiff from '../../mixins/PreviousDiff'

export default {
  name: 'WrittenRoomRow',
  components: {
    SelectYear,
    EditDialog,
    SelectDialog,
  },
  mixins: [PreviousDiff],
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: [Number, String],
      required: true,
    },
    roomIndex: {
      type: Number,
      required: true,
    },
    remarkOptions: {
      type: Array,
      default: () => ([]),
    },
    readonly: {
      type: [Number, Boolean],
      default: false,
    },
    statuses: {
      type: Array,
      default: () => ([]),
    },
    reasons: {
      type: Array,
      default: () => ([]),
    },
    drawings: {
      type: Array,
      default: () => ([
        { id: null, value: '' },
        { id: 1, value: '○' },
        { id: 0, value: '×' },
      ]),
    },
    error: {
      type: Object,
      default: () => ({}),
    },
    created: {
      type: Boolean,
      default: false,
    },
    applied: {
      type: Boolean,
      default: false,
    },
    diffDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        { text: '建材名、商品名等', value: 'written_material', width: '20%' },
        { text: '備考／その他', value: 'written_remarks', width: '20%' },
        { text: '図面の有無', value: 'has_drawings', width: '5%' },
        { text: '石綿含有の可能性', value: 'written_status_id', width: '10%' },
        { text: '判断根拠', value: 'written_reason_id', width: '20%' },
        { text: '分析予定', value: 'analysis_scheduled', width: '20%' },
        { text: '', value: 'delete', width: '5%' },
      ],
      scheduledItems: ['', '不明', 'AS予定', 'VS予定', 'NS(AS/VSしない)'],
    }
  },
  watch: {
    diffDisabled() {
      this.disableDiff = this.diffDisabled
    },
  },
  methods: {
    onAddRowButtonClicked() {
      this.item.surveys.push({
        written_material: '',
        written_remarks: '',
        has_drawings: '',
        written_status_id: '',
        written_reason_id: '',
        analysis_scheduled: '',
      })
    },
    onDeletionButtonClicked(item) {
      const index = this.item.surveys.indexOf(item)
      this.item.surveys.splice(index, 1)
    },
    onHasDrawingsChanged(survey) {
      const index = this.item.surveys.indexOf(survey)
      if (survey.has_drawings === 0) {
        // 図面なしの場合は建材名・商品名、含有の可能性、根拠が不明になる。
        this.$set(this.item.surveys[index], 'written_material', '不明')
        this.$set(this.item.surveys[index], 'written_remarks', '不明')
        this.$set(this.item.surveys[index], 'written_status_id', -1)
        this.$set(this.item.surveys[index], 'written_reason_id', -1)
        this.$set(this.item.surveys[index], 'analysis_scheduled', '不明')
      }
    },
    getPreviousSurvey(object, columnName) {
      if (!this.previousObject || !this.previousObject.surveys) {
        return null
      }
      const target = this.previousObject.surveys.filter(item => item.id === object.id)[0] ?? null
      if (!target) {
        return ' '
      }
      const index = this.previousObject.surveys.indexOf(target)
      return this.previousObject && this.previousObject.surveys
        ? this.previousObject.surveys[index][columnName] ?? null
        : null
    },
    previousValue(previous, current, options = null) {
      const option = Array.isArray(options) ? options.filter(opt => opt.id === previous) : null
      return this.hasDiff(previous, current)
        ? `変更前: ${option && option[0] ? option[0].value : (previous ?? '')}`
        : ''
    },
    diffAttributes(previous, current, options = null) {
      return this.created && this.applied
        ? this.$super(PreviousDiff).diffAttributes(previous, current, options)
        : false
    },
    hasDiff(previous, current) {
      return this.created && this.applied
        ? this.$super(PreviousDiff).hasDiff(previous, current)
        : false
    },
  },
}
</script>

<style scoped>
@media screen and (max-width:1320px) {
  .v-btn {
    padding: 0px 4px !important;
  }
}
.add-part {
  width: 20px;
  height: 20px;
}
.delete-part {
  width: 20px;
  height: 20px;
}
.v-card__title {
  font-size: 1rem;
}
</style>
